export const isPresent = (array) => Array.isArray(array) && array.length > 0;
export const isEmpty = (array) => !isPresent(array);

export const times = (n) => [...Array(n)];
